module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-inner"
  }, [_c('div', {
    staticClass: "footer-left"
  }, [_vm._v("\n      Copyright © 2020 - 2025 "), _c('a', {
    attrs: {
      "href": "https://www.bqrdh.com",
      "target": "_blank"
    }
  }, [_vm._v("不求人导航")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("闽ICP备19026837号")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_c('i', {
    staticClass: "fa fa-at"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://shop.bqrdh.com",
      "target": "_blank"
    }
  }, [_vm._v("阿里内购网")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-at"
  }), _c('a', {
    attrs: {
      "href": "https://jd.bqrdh.com",
      "target": "_blank"
    }
  }, [_vm._v("京内购")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d499aa4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/index.vue
// module id = 145
// module chunks = 1